import { useCallback } from "react";

import useTypedContext from "hooks/useTypedContext";
import useAacFlags from "hooks/useAacFlags";
import { AccountContext } from "views/AccountWrapper";
import { Module, SpaceAccessLevel, Stack } from "types/generated";
import { hasSpaceAccessAtLeast } from "utils/user";
import { hasAtLeastReadAccess } from "utils/access";

const useHasEntityReadAccess = (): ((
  entity?: Partial<Pick<Stack | Module, "canWrite" | "spaceDetails" | "space">>
) => boolean) => {
  const { viewer } = useTypedContext(AccountContext);
  const { customAccessRoles } = useAacFlags();

  return useCallback(
    (entity?: Partial<Pick<Stack | Module, "canWrite" | "spaceDetails" | "space">>) => {
      if (!entity) {
        return false;
      }

      if (viewer.admin) {
        return true;
      }

      if (entity.canWrite) {
        return true;
      }

      if (customAccessRoles) {
        return hasAtLeastReadAccess(viewer, entity.spaceDetails?.id || entity.space);
      }

      if (!entity.spaceDetails?.accessLevel) {
        return false;
      }

      return hasSpaceAccessAtLeast(entity.spaceDetails?.accessLevel, SpaceAccessLevel.Read);
    },
    [customAccessRoles, viewer]
  );
};

export default useHasEntityReadAccess;
